import { render } from "./uploadTemplate.vue?vue&type=template&id=554b6bc9&scoped=true"
import script from "./uploadTemplate.vue?vue&type=script&lang=js"
export * from "./uploadTemplate.vue?vue&type=script&lang=js"

import "./uploadTemplate.vue?vue&type=style&index=0&id=554b6bc9&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554b6bc9"]])

export default __exports__